export const FACEBOOK_COMMENT_REQUIRED_SCOPES = [
  "pages_show_list",
  "pages_read_engagement",
  "pages_manage_engagement",
  "pages_read_user_content",
  "pages_manage_metadata",
];

export const FACEBOOK_MANAGEMENT_SCOPE =
  "public_profile,pages_manage_posts,pages_read_engagement,pages_show_list,pages_manage_engagement,pages_read_user_content,pages_manage_metadata,business_management";

export const buildCommentAutomationMetadata = (grantedScopes = []) => {
  const normalizedScopes = Array.from(
    new Set((grantedScopes || []).filter(Boolean))
  );

  return {
    grantedScopes: normalizedScopes,
    webhookSubscribed: false,
    webhookSubscribedAt: null,
    commentAutomationEligible: FACEBOOK_COMMENT_REQUIRED_SCOPES.every(
      (scope) => normalizedScopes.includes(scope)
    ),
    commentAutomationPaused: false,
    commentAutomationPauseReason: null,
  };
};

export const fetchGrantedFacebookScopes = async (userAccessToken) => {
  if (!userAccessToken) {
    return [];
  }

  try {
    const response = await fetch(
      `https://graph.facebook.com/v21.0/me/permissions?access_token=${encodeURIComponent(
        userAccessToken
      )}`
    );
    const data = await response.json();
    return (data?.data || [])
      .filter((permission) => permission.status === "granted")
      .map((permission) => permission.permission)
      .filter(Boolean);
  } catch (error) {
    console.error("Không thể lấy granted scopes từ Facebook:", error);
    return [];
  }
};

export const buildConnectedFanpageRecord = (
  page,
  {
    accessToken,
    grantedScopes = [],
    tokenStatus = "active",
    tokenExpiry = null,
    tokenError = null,
  } = {}
) => {
  const metadata = buildCommentAutomationMetadata(grantedScopes);
  const record = {
    id: page.id,
    name: page.name,
    access_token: accessToken ?? page.access_token ?? null,
    category: page.category || "",
    connectedAt: Date.now(),
    lastRefreshed: Date.now(),
    tokenStatus,
    tokenExpiry,
    ...metadata,
  };

  if (tokenError) {
    record.tokenError = tokenError;
  }

  return record;
};
